import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputControlBase } from './../forms/input-control.base';
import { SelectionItem } from '../astral-components/astral-option';

export { ISelectionItem, SelectionItem, SelectionItemImpl, ValueTFn } from '../astral-components/astral-option';

/** @deprecated Use `astral-select` in new or Astralized templates. */
@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectComponent<TValue = any> extends InputControlBase {
  constructor() {
    super();
  }

  @Input() itemsSource: SelectionItem<TValue>[];
  @Input() trackBy?: (item: SelectionItem<TValue>) => unknown;
  @Input() multiple = false;
  @Input() allValue: TValue;
  @Input() allMode: 'disabled' | 'noneEqualsAll' | 'standard' = 'disabled';
  @Input() clearOthers: boolean;
  @Output() addonClick = new EventEmitter<FormControl>();

  private updating = false;
  private oldValue: TValue[];

  ngOnInit() {
    super.ngOnInit();
    if (this.allMode === 'disabled' || !this.multiple) {
      return;
    }
    this.oldValue = this.control.value;

    if (this.itemsSource) {
      const nonStringValues = !this.itemsSource.every(item => typeof item.value === 'string') && this.multiple;
      // TODO: make 'noneEqualsAll' multiselect work properly with enum values (allValue -?)
      if (nonStringValues) this.allMode = 'standard';
    }

    this.subscription.add(
      this.control.valueChanges.subscribe((value: TValue[]) => {
        if (this.updating) {
          return;
        }
        if (!this.itemsSource) {
          this.oldValue = value;
          return;
        }
        this.updating = true;

        value = value || [];
        const allWasSelected = this.oldValue?.find(v => v === this.allValue) !== undefined;
        const allIsSelected = value.find(v => v === this.allValue) !== undefined;
        let newValue = value;

        if (this.allMode === 'noneEqualsAll') {
          if (
            (!allWasSelected && allIsSelected) ||
            value.length === 0 ||
            (value.length === this.itemsSource.length - 1 && !allIsSelected)
          ) {
            newValue = [this.allValue];
          } else if (allWasSelected && allIsSelected && value.length > 1) {
            if (value.length === this.itemsSource.length) {
              newValue = [this.allValue];
            } else {
              newValue = value.filter(v => v !== this.allValue);
            }
          }
        }
        if (this.allMode === 'standard') {
          if (allIsSelected) {
            newValue = this.itemsSource.map(v => v.value);
          }
          if (allWasSelected && !allIsSelected) {
            newValue = [];
          }
        }

        if (newValue !== value) {
          this.control.setValue(newValue);
        }
        this.oldValue = newValue;
        this.updating = false;
      })
    );
  }

  addonClicked(): boolean {
    for (let controlName of Object.keys(this.control.parent.controls)) {
      let currentControl = this.control.parent.get(controlName);
      if (currentControl !== this.control) {
        currentControl.setValue(undefined);
      }
    }

    this.addonClick.emit(this.control);
    return false;
  }

  get paddingClass(): any {
    return { addonPadding: this.showClearOthers };
  }

  get showClearThis(): boolean {
    return !this.control.isReadonly && !this.control.required;
  }
  get anyIcons(): boolean {
    return Array.isArray(this.itemsSource) && this.itemsSource.some(item => !!item.icon);
  }

  trackItem(item: SelectionItem<TValue>): unknown {
    return this.trackBy ? this.trackBy(item) : item;
  }

  get showClearOthers(): boolean {
    if (!this.clearOthers) {
      return false;
    }

    if (Object.keys(this.control.parent.controls).length < 2) return false;

    if (this.allMode === 'noneEqualsAll' && Array.isArray(this.control.value)) {
      return this.control.value.length > 0 && this.control.value[0] !== this.allValue;
    }
    if (this.control.value !== undefined && this.control.value !== null && this.control.value === this.allValue) {
      return false;
    }
    return !!this.control.value || this.control.value === 0;
  }

  showAddonHelp = false;

  onAddonMouseEnter() {
    this.showAddonHelp = true;
  }

  onAddonMouseLeave() {
    this.showAddonHelp = false;
  }

  clearBtnClicked(): boolean {
    this.onClearBtnMouseLeave();
    if (this.control.value !== undefined) {
      this.control.setValue(undefined);
      this.control.markAsDirty();
    }

    this.addonClick.emit(this.control);
    return false;
  }

  showClearBtnHelp = false;

  onClearBtnMouseEnter() {
    this.showClearBtnHelp = true;
  }

  onClearBtnMouseLeave() {
    this.showClearBtnHelp = false;
  }

  onOpenChange(e: boolean) {
    if (!e) {
      this.onblur();
    } else {
      this.onfocus();
    }
  }
}
